import { useI18n } from '../i18n'

export function KontaktPage() {
  const { t } = useI18n()
  return (
    <div className="mx-auto max-w-2xl px-4 py-12">
      <h1 className="mb-6 text-2xl font-bold text-text">{t('footer.kontakt')}</h1>
      <div className="text-sm text-text-muted space-y-3">
        <p>Bei Fragen oder Anmerkungen erreichst du mich per E-Mail:</p>
        <p>
          <a href="mailto:jav@masterlevel.de" className="text-primary hover:underline">
            jav@masterlevel.de
          </a>
        </p>
      </div>
    </div>
  )
}
